/**
 * 配置版本变化的通知（给不在 Redux lookup cache 里的模块级缓存用）。
 *
 * Redux 里的 lookup（useLookup）由 lookupSlice.applyServerVersions 失效；但表单目录
 * （useTaskCategoryData，按表单码取显示名、建单表单 schema）和种类表单（useKindForm，C1）各有
 * 自己的模块级缓存，以前只靠 5 分钟 TTL / 刷新页面才更新——表单改名后详情页、建单页一直显示旧名。
 * 拉到 `GET /system/config/versions` 的地方（useConfigVersionBootstrap / useConfigVersionRevalidator）
 * 调 `emitResourceVersionChanges(prev, next)`，订阅者按资源名（`task_subtypes` 等）自己清缓存重拉。
 * 手机端按同一个配置版本失效。
 */

type Listener = (resources: Set<string>) => void;

const listeners = new Set<Listener>();

/** 版本变了的资源名：key 形如 `<resource>:tenant:100`，取冒号前那段。 */
export function changedResources(prev: Record<string, string>, next: Record<string, string>): Set<string> {
  const out = new Set<string>();
  for (const key of Object.keys(next)) {
    if (prev[key] !== next[key]) {
      const resource = key.split(":")[0];
      if (resource) out.add(resource);
    }
  }
  return out;
}

export function onResourceVersionChange(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitResourceVersionChanges(prev: Record<string, string>, next: Record<string, string>): void {
  const resources = changedResources(prev, next);
  if (resources.size === 0) return;
  for (const listener of [...listeners]) {
    try {
      listener(resources);
    } catch (err) {
      console.warn("[configVersionEvents] listener failed", err);
    }
  }
}
